import { render, staticRenderFns } from "./viewEvaluate.vue?vue&type=template&id=4a1050a6&scoped=true&"
import script from "./viewEvaluate.vue?vue&type=script&lang=js&"
export * from "./viewEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./viewEvaluate.vue?vue&type=style&index=0&id=4a1050a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1050a6",
  null
  
)

export default component.exports